<template>
  <div class="vue-csv-uploader">
    <div class="form">
      <div class="vue-csv-uploader-part-one" v-show="true">
        <div class="custom-control custom-checkbox" v-if="headers === null">
          <slot
            name="hasHeaders"
            :headers="hasHeaders"
            :toggle="toggleHasHeaders"
          >
            <input
              :class="checkboxClass"
              type="checkbox"
              :id="makeId('hasHeaders')"
              :value="hasHeaders"
              @change="toggleHasHeaders"
            />
            <label class="custom-control-label" :for="makeId('hasHeaders')">
              File Has Headers
            </label>
          </slot>
        </div>
        <form enctype="multipart/form-data">
          <label class="jumbotron drop_zone" for="inputFile">
            <b-icon-cloud-upload-fill variant="secondary" font-scale="5" />
            <b-card-text class="lead" style="margin-bottom: -0.75rem">
              Choose a file from your computer
            </b-card-text>
            <b-icon-blank v-if="!this.$refs.csv" />
            <b-badge
              :variant="showErrorMessage ? 'danger' : 'primary'"
              v-if="this.$refs.csv"
              >{{ this.$refs.csv.files[0].name }}</b-badge
            >
            <input
              id="inputFile"
              ref="csv"
              type="file"
              @change.prevent="validFileMimeType"
              :class="inputClass"
              name="csv"
            />
          </label>
        </form>
        <div class="form-group">
          <slot name="error" v-if="showErrorMessage">
            <b-alert show variant="danger">File type is invalid</b-alert>
          </slot>
          <!-- <slot name="next" :load="load" v-if="!disabledNextButton">
            <button
              type="submit"
              :disabled="disabledNextButton"
              :class="buttonClass"
              @click.prevent="load"
            >
              {{ loadBtnText }}
            </button>
          </slot> -->
          <div class="form-group" v-if="!disabledNextButton">
            <slot name="submit" :submit="submit">
              <input
                type="submit"
                :class="buttonClass"
                @click.prevent="submit"
                :value="submitBtnText"
              />
            </slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { every, get, isArray, map } from "lodash";
// import axios from "axios";
import mimeTypes from "mime-types";
export default {
  props: {
    value: File,
    url: {
      type: String,
    },
    mapFields: {
      required: true,
    },
    callback: {
      type: Function,
      default: () => ({}),
    },
    catch: {
      type: Function,
      default: () => ({}),
    },
    finally: {
      type: Function,
      default: () => ({}),
    },
    parseConfig: {
      type: Object,
      default() {
        return {};
      },
    },
    headers: {
      default: null,
    },
    loadBtnText: {
      type: String,
      default: "Next",
    },
    submitBtnText: {
      type: String,
      default: "Submit",
    },
    ignoreOptionText: {
      type: String,
      default: "Ignore",
    },
    autoMatchFields: {
      type: Boolean,
      default: false,
    },
    autoMatchIgnoreCase: {
      type: Boolean,
      default: false,
    },
    tableClass: {
      type: String,
      default: "table",
    },
    checkboxClass: {
      type: String,
      default: "form-check-input",
    },
    buttonClass: {
      type: String,
      default: "btn btn-primary",
    },
    inputClass: {
      type: String,
      default: "form-control-file",
    },
    validation: {
      type: Boolean,
      default: true,
    },
    fileMimeTypes: {
      type: Array,
      default: () => {
        return [
          //   "text/csv",
          //   "text/x-csv",
          //   "application/vnd.ms-excel",
          //   "text/plain",
          // "application/vnd.ms-excel.sheet.binary.macroEnabled.12",
          "application/vnd.ms-excel.sheet.macroEnabled.12",
        ];
      },
    },
    tableSelectClass: {
      type: String,
      default: "form-control",
    },
    canIgnore: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    form: {
      csv: null,
    },
    fieldsToMap: [],
    map: {},
    hasHeaders: true,
    csv: null,
    sample: null,
    isValidFileMimeType: false,
    fileSelected: false,
    step: 1,
  }),
  created() {
    this.initializeFromProps();
  },
  methods: {
    initializeFromProps() {
      this.hasHeaders = this.headers;
      if (isArray(this.mapFields)) {
        this.fieldsToMap = map(this.mapFields, (item) => {
          return {
            key: item,
            label: item,
          };
        });
      } else {
        this.fieldsToMap = map(this.mapFields, (item, key) => {
          return {
            key: key,
            label: item.label,
            map: item.map == null ? "" : item.map,
          };
        });
      }
    },
    submit() {
      this.form.csv = this.$refs.csv.files[0];
      console.log(this.form.csv.name);
      this.$emit("input", this.form.csv);
    },
    validFileMimeType() {
      let file = this.$refs.csv.files[0];
      const mimeType =
        file.type === "" ? mimeTypes.lookup(file.name) : file.type;
      if (file) {
        this.fileSelected = true;
        this.isValidFileMimeType = this.validation
          ? this.validateMimeType(mimeType)
          : true;

        // go straight to load
        this.step = 2;
      } else {
        this.isValidFileMimeType = !this.validation;
        this.fileSelected = false;
      }
    },
    validateMimeType(type) {
      return this.fileMimeTypes.indexOf(type) > -1;
    },
    back() {
      this.step = 1;
    },
    toggleHasHeaders() {
      this.hasHeaders = !this.hasHeaders;
    },
    makeId(id) {
      return `${id}${this._uid}`;
    },
  },
  watch: {
    map: {
      deep: true,
      handler: function (newVal) {
        if (!this.url) {
          let hasAllKeys = Array.isArray(this.mapFields)
            ? every(this.mapFields, function (item) {
                return Object.prototype.hasOwnProperty.call(newVal, item);
              })
            : every(this.mapFields, function (item, key) {
                return Object.prototype.hasOwnProperty.call(newVal, key);
              });
          if (hasAllKeys) {
            this.submit();
          }
        }
      },
    },
    sample(newVal) {
      if (this.autoMatchFields) {
        if (newVal !== null) {
          this.fieldsToMap.forEach((field) => {
            newVal[0].forEach((columnName, index) => {
              if (this.autoMatchIgnoreCase === true) {
                if (
                  field.label.toLowerCase().trim() ===
                  columnName.toLowerCase().trim()
                ) {
                  this.$set(this.map, field.key, index);
                } else if (
                  field.map.toLowerCase().trim() ===
                  columnName.toLowerCase().trim()
                ) {
                  this.$set(this.map, field.key, index);
                }
              } else {
                if (field.label.trim() === columnName.trim()) {
                  this.$set(this.map, field.key, index);
                } else if (field.map.trim() === columnName.trim()) {
                  this.$set(this.map, field.key, index);
                }
              }
            });
          });
        }
      }
    },
    mapFields() {
      this.initializeFromProps();
    },
    toggleActive() {
      this.active.value = !this.active.value;
    },
  },
  computed: {
    firstRow() {
      return get(this, "sample.0");
    },
    showErrorMessage() {
      return this.fileSelected && !this.isValidFileMimeType;
    },
    disabledNextButton() {
      return !this.isValidFileMimeType;
    },
  },
};
</script>

<style lang="scss">
.jumbotron {
  // width: 400px;
  // height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 16px;
  margin-bottom: 1rem;
  // border: 2px dashed #449dc1;
  // background-color: #fff;
  transition: 0.3s ease all;
  label {
    padding: 8px 12px;
    color: #fff;
    // background-color: #41b883;
    transition: 0.3s ease all;
  }
  input {
    display: none;
  }
}

.active-dropzone {
  color: #fff;
  border-color: #fff;
  background-color: #41b883;
  label {
    background-color: #fff;
    color: #41b883;
  }
}
</style>